<div class="d-md-flex align-items-center bg-white p-3" *ngIf="!Filtri.pratiche">
  <a href="javascript:void(0)" class="d-flex align-items-center numeri">
    <label class="font-20"> {{titolo}} </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{collectionSize}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri">
    <label class="font-20"> NUOVI </label>
    &nbsp;
<!--    <span class="badge font-20">{{nuovi}}</span>-->
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{nuovi}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri">
    <label class="font-20"> DA SPEDIRE </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{lavorare}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;
  &nbsp;
  <a href="javascript:void(0)" class="d-flex align-items-center numeri">
    <label class="font-20"> LDV </label>
    &nbsp;
    <div class="d-flex  flex-column  align-items-center justify-content-center" style="padding-top: 3pt">
      <span class="d-flex justify-content-center font-14 font-weight-bold" > {{ldv}} </span>
      <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 0;" [ngStyle]="{'background-color': '#53c954'}" > &nbsp; </span>
    </div>
  </a>
  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;   &nbsp;   &nbsp;   &nbsp;   &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;   &nbsp;   &nbsp;   &nbsp;   &nbsp;
  <label class="container" style=" width: auto; margin: auto; margin-left: 0;">
    <input type="checkbox"  [(ngModel)]="inlineclick" (ngModelChange)="inlineclickChange()">
    <span class="checkmark"></span>
    RIGA CLICCABILE
  </label>
<!--  <div class="col-1 " >-->
<!--    <div class="">-->
<!--      <label for="inlineclick" >riga cliccabile</label>-->
<!--      &nbsp;-->
<!--      <input id="inlineclick" [(ngModel)]="inlineclick" (ngModelChange)="inlineclickChange()" class="" type="checkbox">-->
<!--    </div>-->
<!--  </div>-->
  <div class="ml-auto mt-3 mt-md-0">
    <button *ngIf="statospedire && permission.isPermitted('spedisci')" (click)='spedisci()' type="button" class="btn btn-success rounded-pill py-2"><i
      class="fas fa-upload  font-14 mr-1 text-white"></i>
    <span class="ml-1 text-white font-weight-bold">Spedisci</span>
  </button>
    <button (click)='inviaSMSSelezionati()' *ngIf="permission.isPermitted('invio-sms')" type="button" class="btn btn-green">
      <i-feather name="send" ></i-feather>
      <span class="ml-1">INVIA SMS</span>
    </button>
    <button *ngIf="statoDareCorriere && permission.isPermitted('pagamento-corriere')" (click)='paga_Coriere()' type="button" class="btn btn-green">
      <i class="fas fa-box "></i>
      <span class="ml-1">PAGA CORRIERE</span>
    </button>
    <button  (click)='stampamagnifest()' type="button" class="btn btn-green">
      <i-feather name="printer" class="feather "></i-feather>
      <span class="ml-1">STAMPA</span>
    </button>
    <button *ngIf="isAddEnabled" (click)='Edit()' type="button" class="btn btn-ciano">
      <i class="fas fa-plus-circle "></i>
      <span class="ml-1">AGGIUNGI</span>
    </button>
    <button  (click)='paga_Cliente()' *ngIf="permission.isPermitted('pagato')" type="button" class="btn btn-ciano">
      <i class="far fa-credit-card"></i>
      <span class="ml-1">PAGATO</span>
    </button>
  </div>
</div>
<div *ngIf="hasFilter"  class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body p-t-0 p-b-0">
        <div class="row">
          <div class="col-lg-2" *ngIf="Filtri.pratiche">
            <div class="form-group">
              <label for="codice" class="control-label col-form-label" >CODICE</label>
              <input id="codice"  required [(ngModel)]="Filtri.codice" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div class="col-lg-2" *ngIf="!Filtri.pratiche">
            <div class="form-group">
              <label for="inizio" class="control-label col-form-label" >INIZIO</label>
              <input id="inizio"  required [(ngModel)]="Filtri.inizio" (ngModelChange)="onFilterChange()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-2" *ngIf="!Filtri.pratiche">
            <div class="form-group">
              <label for="fine" class="control-label col-form-label" >FINE</label>
              <input id="fine"  required [(ngModel)]="Filtri.fine" (ngModelChange)="onFilterChange()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche">
            <label for="categorie" required class="control-label col-form-label" > CORRIERE</label>
            <ng-multiselect-dropdown style="" class="font-14" [settings]="corrieredropdownSettings" [placeholder]="'Corriere'" id="categorie" [data]="corrieri"
            [(ngModel)]="corrierisel" (onSelect)="corriereSelezionato($event)" (onDeSelect)="corriereSelezionato($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche">
            <label for="stato" required class="control-label col-form-label" > STATO</label>
            <ng-multiselect-dropdown class="font-14" [settings]="statidropdownSettings" [placeholder]="'Stato'" id="stato" [data]="stati"
            [(ngModel)]="statisel" (onSelect)="statoSelezionato($event)" (onDeSelect)="statoSelezionato($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-lg-2 " *ngIf="!Filtri.pratiche">
            <div class="form-group ">
               <label for="filtro" class="control-label col-form-label" >FILTRO</label>
              <input id="filtro" [(ngModel)]="Filtri.filtro" placeholder="Filtro" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div class="col-lg-2 " *ngIf="permission.isPermitted('agenzia') && !Filtri.pratiche" >
            <div class="form-group">
               <label for="agenzia" class="control-label col-form-label" >AZIENDA</label>
              <input id="agenzia"  [(ngModel)]="Filtri.agenzia" placeholder="Azienda" (ngModelChange)="onFilterChange()" class="form-control" type="text">
            </div>
          </div>
          <div  class=" d-flex  col-lg-6" style="margin-top: 10px">
            <label *ngIf="!Filtri.pratiche" class="container" style="margin-left: 0; width: auto; margin-right: auto;">
              <input type="checkbox"  [(ngModel)]="Filtri.t12" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              Link rapidi: &nbsp;  &nbsp;T12
            </label>
            <label *ngIf="!Filtri.pratiche" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox"  [(ngModel)]="Filtri.ritiro" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              RITIRO
            </label>
            <label *ngIf="!Filtri.pratiche" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.triangolazione" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              TRIANGOLAZIONE
            </label>
            <label *ngIf="!Filtri.pratiche" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox"  [(ngModel)]="Filtri.internazionali" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              INTERNAZIONALI
            </label>
            <label *ngIf="!Filtri.pratiche" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.nazionali" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              NAZIONALI
            </label>
            <label *ngIf="Filtri.pratiche" class="container" style="margin-left: auto; width: auto; ">
              <input type="checkbox" [(ngModel)]="Filtri.chiuse" (ngModelChange)="onFilterChange()">
              <span class="checkmark"></span>
              CHIUSE
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="table-responsive">
    <table class="table  table-hover align-middle mb-0 table-fixed"  >
      <thead class="fi"   >
      <tr >
        <th scope="col" >
          <input type="checkbox" [(ngModel)]="isMasterSel" name="list_name" value="h1"
                 (change)="checkUncheckAll()" />
        </th>
        <th><span class="font-20">Spedizione N.</span></th>
        <th><span class="font-20">Data</span></th>
        <th><span class="font-20">Codice Pratica</span></th>
        <th scope="col"><span class="font-20">Corriere</span></th>
        <th scope="col"><span class="font-20">Lettera di vettura</span></th>
        <th scope="col"><span class="font-20">Note Pratica</span></th>
      </tr>
      </thead>
      <tbody class="scrollable tablelist" >
      <tr *ngFor="let item of Spedizioni | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td  class="align-middle"  >
          <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name"
                 (change)="isAllSelected()" />
        </td>

        <td class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center" style="margin-top: 5pt;" > {{item.progressivo}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.files && item.files.length > 0 && item.files[0] ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <span class="font-14">{{item?.data_inizio_prevista | date: 'dd/MM/yyyy'}}</span>
        </td>
        <td class="align-middle " (click)="Edit(item,true)">
          <span class="font-18">{{item.codicePratica}}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <span *ngIf="item.corriereObject" class="font-18">{{ item.corriereObject.nominativo }}</span>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <div class="d-flex  flex-column  align-items-center justify-content-center">
            <span class="d-flex justify-content-center font-14" style="margin-top: 5pt;" > {{item.ldv}} </span>
            <span class="badge badge-pill px-3 font-weight-bold font-14" style="height: 2pt; margin-top: 5pt;" [ngStyle]="{'background-color': item.costoContrassegno && item.costoContrassegno > 0  ? '#ffc107' : 'transparent'}" > &nbsp; </span>
          </div>
        </td>
        <td class="align-middle" (click)="Edit(item,true)">
          <span class="font-18">{{ item.notePratica }}</span>
        </td>
      </tr>
      </tbody>
    </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
